'use client';
import { useEffect, useState, useRef } from 'react';
import { useRouter } from 'next/navigation';
import EcoImg from 'eco-design/base/eco-img';
import EcoLink from 'eco-design/base/eco-link';
import { StatGetDeviceId } from 'eco-design-micro/EcoStat/config';
import cookie from 'react-cookies';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { LoadingOutlined } from '@ant-design/icons';
import { isEmpty } from 'lodash';
import getLocal from 'eco-design-reliance/getLocal';
import gtm from 'eco-design-reliance/gtm';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import { getIsPadWidth } from 'eco-design-micro/utils-base/devices';
import generateTraceId from 'eco-design-micro/utils-base/generateTraceId';
import { getIsLogin } from 'eco-design-reliance/getIsLogin';
import { getWebToken, loginUser } from 'eco-design-micro/utils-user/web/webToken';
import { fetchGetWeb, fetchPostWeb } from 'eco-design-micro/request2/FetchClient';

import { getGloAIProductList } from 'code-micro/utils/getGloAIProductList';
import EFBundlesCardAI from '@elem/ui/ef-bundles-card-AI';
import styles from '../../index.module.scss';
import { i18nText } from './config';
import getLangFromLocale from '@/utils/singUtil/getLangFromLocale';

const NEW_SEARCH_RESULT_LIST_LOCALES = ['us', 'ca', 'eu', 'uk', 'au', 'za', 'de', 'it', 'fr', 'es', 'jp'];
const websiteUrl = process.env.NEXT_PUBLIC_WEB_HOST;

const DropBoxSearch = ({ callback, ...rest }: any) => {
    const router = useRouter();
    const { locale = '' } = getLocal();
    const [keyword, setKeyword] = useState<string | any>();
    const [searchLoading, setSearchLoading] = useState(false);
    const { appId } = getLangFromLocale(locale as string) as any;

    const [listA, setList] = useState<any[]>([]);
    const [searchResultData, setSearchResultData]: any = useState<any>({});
    const [historyData, setHistoryData] = useState<any[]>([]); // 搜索历史 & 热搜
    const [debouncedValue, setDebouncedValue] = useState<any>(''); // 延后请求的值
    const inputRef: any = useRef<HTMLInputElement>(null);
    const [requestStatus, setRequestStatus] = useState('beforePending'); // 请求状态, 用来判断是否显示空结果的样式

    // const uuid: any = useRef<string>(sessionStorage.getItem('ef_search_ai_session_id') || ''); //  sessionId
    const uuid = useRef<string>(''); // 不要直接读 sessionStorage

    const userId = loginUser()?.user?.userId;
    const [isMobile, setIsMobile] = useState(false);
    const [showType, setShowType] = useState('');

    const handleQueryRecommendList = async (data?: any) => {
        try {
            const deviceId = await StatGetDeviceId({});

            const params = {
                sessionId: uuid?.current,
                triggerPage: 'Brand Search Recommend',
                tid: generateTraceId(),
                userId,
                deviceId: deviceId || '',
                ...data,
            };
            const productRes = await getGloAIProductList(params, locale);
            if (productRes?.code === '0') {
                let finalList = productRes?.data?.items;
                if (finalList?.length > 0) {
                    if (productRes?.data?.items?.length > 8 && finalList[0]?.itemType !== 'shopifyBundle') {
                        finalList = productRes?.data?.items?.slice(0, 8);
                    }
                    if (productRes?.data?.items?.length > 3 && finalList[0]?.itemType === 'shopifyBundle') {
                        finalList = productRes?.data?.items?.slice(0, 3);
                    }
                    setList(finalList || []);
                    setShowType(finalList[0]?.itemType);
                } else {
                    handleQueryProductList();
                }
            } else {
                handleQueryProductList();
            }
        } catch (error) {
            console.log(error);
        }
    };
    const closeFn = () => {
        callback && callback();
        EcoDesignEventsBus.emit('ef-header-search-close');
    };

    const clearKeyword = () => {
        setKeyword('');
    };

    const handleQueryProductList = async () => {
        const res = await fetchGetWeb(`/shopify/web/shopifyProductVariant/aiRecommend/fallback`, null, {
            locale,
        });
        if (res?.code === '0') {
            const productList = res?.data || [];
            setShowType('shopifyProduct');
            handleFormatProductList(productList);
        } else {
        }
    };

    const handleFormatProductList = (productList: any[]) => {
        const formatList: any[] = [];
        productList.forEach((item: any) => {
            formatList.push({
                itemId: item?.variantId,
                itemType: 'shopifyProduct',
                variants: [item],
            });
        });

        setList(formatList?.slice(0, 8));
    };

    //  点击回车
    const onEnterHandle = (e: any) => {
        e.preventDefault();
        if (e.keyCode === 13) {
            location.href = `/${locale}/search/${encodeURIComponent(keyword)}`;
            gtm.push({
                event: 'uaEvent',
                event_name: 'search_review',
                product_name: keyword,

                __btn_id1: 'header-search-input-v3',
                __btn_id2: 'header-search-input-v3',
                __btn_type: 'common',
            });
        }

        if (!!keyword) {
            if (typeof window !== 'undefined') {
                localStorage.setItem('search_entry', 'Enter');
            }
            gtm.push({
                event: 'uaEvent',
                event_name: 'search',
                search_term: keyword,
                button_name: keyword,
                type: 'Enter',
                is_input: 'Yes',
                source_method: null,
            });
        }
    };

    const handleQueryVipData = async () => {
        let infoData = null;

        if (!!getIsLogin()) {
            //const userInfoRes = await getAIUserInfo(locale as string);
            const tokenA = getWebToken();
            const userInfoRes = await fetchGetWeb(`/integral/web/aiRecommend/userInfo`, null, {
                locale,
                token: tokenA,
            });
            if (userInfoRes?.code === '0') {
                infoData = userInfoRes?.data;
            }

            await handleQueryRecommendList({ ...infoData });
        } else {
            await handleQueryRecommendList({});
        }
    };

    const handleItemClick = (item: any) => {
        sessionStorage.setItem('ai_recommend_module', 'AI Brand Search Recommend');
        if (typeof window !== 'undefined') {
            localStorage.setItem('search_entry', 'Recommendations');
        }

        // 新增 ai cookie 埋点
        const expires = new Date();
        expires.setDate(expires.getDate() + 7);

        const cookieOptions = {
            path: '/',
            domain: '.ecoflow.com',
            expires,
        };

        cookie.save('ai_entry_type', showType === 'shopifyProduct' ? 'AI Recommend Search_Shopify Product Page' : 'AI Recommend Search_Official Website Page', {
            path: '/',
            domain: '.ecoflow.com',
        });
        cookie.save('ai_jump_url', item?.url || `https://${locale}.ecoflow.com/products/${item?.handle}?variant=${item?.variantId}`, {
            path: '/',
            domain: '.ecoflow.com',
        });

        cookie.save(
            'display_type',
            showType === 'shopifyProduct' ? 'AI Recommend Search_Shopify Product Page' : 'AI Recommend Search_Official Website Page',
            cookieOptions,
        );

        gtm.push({
            event: 'uaEvent',
            event_name: 'search',
            search_term: item?.productName || item?.sceneTitle || item?.productTitle || item?.skuTitle || '',
            button_name: item?.productName || item?.sceneTitle || item?.productTitle || item?.skuTitle || '',
            type: 'AI Recommend Search_Recommendations',
            display_type: showType === 'shopifyProduct' ? 'Shopify Product Page' : 'Official Website Page',
            is_input: 'No',
            source_method: null,
        });
    };

    const handleHotItemClick = (item: any, category: string) => {
        const value = item?.text;
        // setKeyword(value);

        if (!!value) {
            location.href = `/${locale}/search/${encodeURIComponent(value)}`;

            const typeValue = category === 'hotSearch' ? 'Hot Search' : 'Search History';

            if (typeof window !== 'undefined') {
                localStorage.setItem('search_entry', typeValue);
            }

            gtm.push({
                event: 'uaEvent',
                event_name: 'search',
                type: typeValue,
                is_input: 'No',
                search_term: value,
                button_name: value,
                display_type: 'Official Website Page',
                source_method: null,
            });
        }
    };

    const handleSuggestedProductItemClick = (item: any) => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('search_entry', 'Suggest Product');
        }
        gtm.push({
            event: 'uaEvent',
            event_name: 'search',
            search_term: item?.spuName || '',
            button_name: item?.spuName || '',
            type: 'AI Recommend Search_Suggest Product',
            is_input: 'Yes',
            source_method: null,
        });
    };
    const handleSuggestedDocItemClick = (item: any) => {
        if (typeof window !== 'undefined') {
            localStorage.setItem('search_entry', 'Suggested Search');
        }
        const finalTitle = item?.title?.replace(/<em>/g, '').replace(/<\/em>/g, '');

        gtm.push({
            event: 'uaEvent',
            event_name: 'search',
            search_term: finalTitle || '',
            button_name: finalTitle || '',
            type: 'Suggested Search',
            is_input: 'Yes',
            source_method: null,
        });

        setTimeout(() => {
            location.href = `/${locale}/search/${encodeURIComponent(finalTitle)}`;
        }, 200);
    };

    const handleClearHistory = () => {
        console.log('clear history');
    };

    const handleFormatHistoryText = (text: string) => {
        if (!text) return '';
        if (text?.length > 20) {
            return text?.slice(0, 20) + '...';
        }
        return text;
    };

    const handleAIInputChange = async (value: any) => {
        setRequestStatus('pending');
        const params = {
            query: value,
            scene: 'bar',
            searchScope: 'products,supports',
            sessionId: uuid.current || '',
            userId,
        };

        try {
            // const res: any = await getAISearchRes(params);
            const res = await fetchPostWeb(`/website/aiSearch/homeSearch`, params, {
                locale,
            });
            if (res.code === '0') {
                const result = res?.data;
                setSearchResultData(result || {});
                setSearchLoading(false);
                setRequestStatus('fulfilled');
            } else {
                setSearchResultData({});
                setSearchLoading(false);
                setRequestStatus('fulfilled');
            }
        } catch (error) {
            console.log(error, 'error=======');
            setSearchResultData({});
            setSearchLoading(false);
            setRequestStatus('fulfilled');
        }
    };

    const handleInputChange = (value: any) => {
        if (!!NEW_SEARCH_RESULT_LIST_LOCALES.includes(locale)) {
            setSearchLoading(true);
            setKeyword(value);
        } else {
            setKeyword(value);
        }
    };

    const handleQueryAIHomeSuggestion = async (sessionId: string) => {
        try {
            const data = {
                sessionId: sessionId || uuid.current,
                appid: appId,
                userId,
            };
            const res = await fetchPostWeb(`/website/aiSearch/homeSuggestion`, data, {
                locale,
            });
            // const res = await queryAIHomeSuggestion(locale, data as any);

            if (res.code === '0') {
                const result = res?.data;
                setHistoryData(result || []);
            } else {
                setHistoryData([]);
            }
        } catch (error) {
            setHistoryData([]);
        }
    };

    useEffect(() => {
        if (!!NEW_SEARCH_RESULT_LIST_LOCALES.includes(locale)) {
            if (!!keyword) {
                inputRef.current = setTimeout(() => {
                    setDebouncedValue(keyword);
                }, 300);
            }

            if (!keyword) {
                setSearchLoading(false);

                setRequestStatus('beforePending');
                setDebouncedValue('');
                setSearchResultData({});
                if (uuid.current) {
                    handleQueryAIHomeSuggestion(uuid.current);
                }
            }
        }

        return () => {
            clearTimeout(inputRef.current);
        };
    }, [keyword]);

    useEffect(() => {
        if (debouncedValue) {
            handleAIInputChange(debouncedValue);
        }
    }, [debouncedValue]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const currentSessionId: any = sessionStorage.getItem('ef_search_ai_session_id');

            uuid.current = currentSessionId;
            handleQueryAIHomeSuggestion(currentSessionId);
        }
        const isMobileValue = getIsPadWidth();
        setIsMobile(isMobileValue);
    }, []);

    useEffect(() => {
        if (!uuid.current) return;
        handleQueryVipData();

        return () => {
            setShowType('');
        };
    }, [uuid.current]);

    return (
        <div className={`${styles.searchbox} dropdown-inter`}>
            <div className="search-inner">
                <div className="searchbox-h">
                    <span className="searchbox-icon">
                        {!!searchLoading && !!NEW_SEARCH_RESULT_LIST_LOCALES.includes(locale) ? (
                            <LoadingOutlined color="#18191B" />
                        ) : (
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <circle cx="11" cy="11" r="6" stroke="black" strokeWidth="1.6" />
                                <path
                                    d="M19.3841 20.5154C19.6965 20.8279 20.203 20.8279 20.5154 20.5154C20.8279 20.203 20.8279 19.6965 20.5154 19.3841L19.9497 19.9497L19.3841 20.5154ZM15 15L14.4343 15.5657L19.3841 20.5154L19.9497 19.9497L20.5154 19.3841L15.5657 14.4343L15 15Z"
                                    fill="black"
                                />
                            </svg>
                        )}
                    </span>
                    <input
                        type="text"
                        value={keyword}
                        onChange={(e) => handleInputChange(e.target.value)}
                        className="searchbox-input header-search-input-v3 GtmModuleData-btn-common"
                        data-btn-id="header-search-input-v3"
                        onKeyUp={onEnterHandle}
                        placeholder={i18nText[locale]?.site_nav_search || i18nText.en.site_nav_search}
                        onClick={() => {
                            gtm.push({
                                event: 'uaEvent',
                                event_name: 'click_search',
                                button_name: 'Search',
                            });
                        }}
                    />
                    {!!keyword && !!NEW_SEARCH_RESULT_LIST_LOCALES.includes(locale) && (
                        <span
                            className="searchbox-input-delete"
                            aria-label={i18nText[locale]?.search_delete || i18nText.en.search_delete}
                            onClick={clearKeyword}
                        >
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <g clipPath="url(#clip0_466_38365)">
                                    <rect width="20" height="20" rx="10" fill="#83868A" />
                                    <path
                                        d="M13.3334 6.66667L6.66675 13.3333"
                                        stroke="white"
                                        strokeWidth="1.66667"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M6.66675 6.66667L13.3334 13.3333"
                                        stroke="white"
                                        strokeWidth="1.66667"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_466_38365">
                                        <rect width="20" height="20" rx="10" fill="white" />
                                    </clipPath>
                                </defs>
                            </svg>
                        </span>
                    )}
                    {!!isMobile && (
                        <span className="searchbox-del" aria-label={i18nText[locale]?.search_delete || i18nText.en.search_delete} onClick={closeFn}>
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path
                                    d="M5 4.16663L15.8333 15M15.8333 4.16663L5 15"
                                    stroke="#010101"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </span>
                    )}
                </div>

                <div className="searchbox-content-wrapper">
                    {/* 历史搜索/热门搜索 */}
                    {!!NEW_SEARCH_RESULT_LIST_LOCALES.includes(locale) &&
                        !debouncedValue &&
                        // requestStatus !== 'fulfilled' &&
                        !!historyData.length &&
                        historyData.map(
                            (item1: any, index1: number) =>
                                item1?.items?.length > 0 && (
                                    <div key={index1} className="searchbox-history-content">
                                        <div className="searchbox-history-content-wrapper">
                                            <div className="searchbox-history-content-header">
                                                {item1?.category === 'hotSearch' && (
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M6.90277 18.252C5.83458 15.9687 6.39679 14.6557 7.2401 13.457C8.13963 12.087 8.36451 10.774 8.36451 10.774C8.36451 10.774 9.09537 11.6874 8.81427 13.1716C10.0511 11.7445 10.276 9.46111 10.1073 8.60486C12.9184 10.6028 14.1552 14.9983 12.5248 18.1949C21.1828 13.1716 14.6612 5.69358 13.5368 4.8944C13.9303 5.75066 13.9866 7.17776 13.1995 7.86277C11.9064 2.83938 8.70183 1.86896 8.70183 1.86896C9.09538 4.43773 7.35254 7.23484 5.66592 9.34695C5.6097 8.31944 5.55348 7.63443 4.99127 6.60692C4.87883 8.49069 3.47332 9.97487 3.07978 11.8586C2.57379 14.4274 3.47332 16.2541 6.90277 18.252Z"
                                                            fill="black"
                                                        />
                                                        <path
                                                            d="M6.90277 18.252C5.83458 15.9687 6.39679 14.6557 7.2401 13.457C8.13963 12.087 8.36451 10.774 8.36451 10.774C8.36451 10.774 9.09537 11.6874 8.81427 13.1716C10.0511 11.7445 10.276 9.46111 10.1073 8.60486C12.9184 10.6028 14.1552 14.9983 12.5248 18.1949C21.1828 13.1716 14.6612 5.69358 13.5368 4.8944C13.9303 5.75066 13.9866 7.17776 13.1995 7.86277C11.9064 2.83938 8.70183 1.86896 8.70183 1.86896C9.09538 4.43773 7.35254 7.23484 5.66592 9.34695C5.6097 8.31944 5.55348 7.63443 4.99127 6.60692C4.87883 8.49069 3.47332 9.97487 3.07978 11.8586C2.57379 14.4274 3.47332 16.2541 6.90277 18.252Z"
                                                            fill="url(#paint0_linear_479_12239)"
                                                        />
                                                        <defs>
                                                            <linearGradient
                                                                id="paint0_linear_479_12239"
                                                                x1="7.29631"
                                                                y1="1.81187"
                                                                x2="17.724"
                                                                y2="16.2879"
                                                                gradientUnits="userSpaceOnUse"
                                                            >
                                                                <stop stopColor="#F0F0F0" />
                                                                <stop offset="1" stopColor="#9A9A9A" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>
                                                )}

                                                {item1?.category === 'recentSearch' && (
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path
                                                            d="M10 2.5C12.0709 2.5 13.9455 3.33998 15.3027 4.69727C16.66 6.05454 17.5 7.92913 17.5 10C17.5 12.0709 16.66 13.9455 15.3027 15.3027C13.9455 16.66 12.0709 17.5 10 17.5C7.92913 17.5 6.05454 16.66 4.69727 15.3027C3.33999 13.9455 2.5 12.0709 2.5 10C2.5 7.92913 3.33999 6.05454 4.69727 4.69727C6.05454 3.33999 7.92913 2.5 10 2.5ZM10 5.20801C9.65494 5.20801 9.3752 5.488 9.375 5.83301V10.833C9.375 11.0557 9.49392 11.2622 9.68652 11.374C9.87916 11.4856 10.1172 11.4864 10.3105 11.376L13.2266 9.70898C13.5261 9.53768 13.6302 9.15609 13.459 8.85645C13.2877 8.55701 12.906 8.45295 12.6064 8.62402L10.625 9.75488V5.83301C10.6248 5.488 10.3451 5.20801 10 5.20801Z"
                                                            fill="#010101"
                                                        />
                                                        <path
                                                            d="M10 2.5C12.0709 2.5 13.9455 3.33998 15.3027 4.69727C16.66 6.05454 17.5 7.92913 17.5 10C17.5 12.0709 16.66 13.9455 15.3027 15.3027C13.9455 16.66 12.0709 17.5 10 17.5C7.92913 17.5 6.05454 16.66 4.69727 15.3027C3.33999 13.9455 2.5 12.0709 2.5 10C2.5 7.92913 3.33999 6.05454 4.69727 4.69727C6.05454 3.33999 7.92913 2.5 10 2.5ZM10 5.20801C9.65494 5.20801 9.3752 5.488 9.375 5.83301V10.833C9.375 11.0557 9.49392 11.2622 9.68652 11.374C9.87916 11.4856 10.1172 11.4864 10.3105 11.376L13.2266 9.70898C13.5261 9.53768 13.6302 9.15609 13.459 8.85645C13.2877 8.55701 12.906 8.45295 12.6064 8.62402L10.625 9.75488V5.83301C10.6248 5.488 10.3451 5.20801 10 5.20801Z"
                                                            fill="url(#paint0_linear_548_1777)"
                                                        />
                                                        <defs>
                                                            <linearGradient
                                                                id="paint0_linear_548_1777"
                                                                x1="7.42334"
                                                                y1="3.8128"
                                                                x2="15.5381"
                                                                y2="16.8579"
                                                                gradientUnits="userSpaceOnUse"
                                                            >
                                                                <stop stopColor="#F0F0F0" />
                                                                <stop offset="1" stopColor="#9A9A9A" />
                                                            </linearGradient>
                                                        </defs>
                                                    </svg>
                                                )}
                                                <p className="searchbox-content-header-text">
                                                    {item1?.category === 'hotSearch'
                                                        ? i18nText[locale]?.hot_search || i18nText.en.hot_search
                                                        : i18nText[locale]?.search_history || i18nText.en.search_history}
                                                </p>
                                            </div>
                                        </div>

                                        <div className="searchbox-history-list">
                                            {item1?.items?.slice(0, 5)?.map((hotItem: any, index: number) => {
                                                return (
                                                    <div
                                                        className="searchbox-history-item"
                                                        key={index}
                                                        onClick={() => handleHotItemClick(hotItem, item1?.category)}
                                                    >
                                                        <p className="searchbox-history-item-text">{handleFormatHistoryText(hotItem?.text)}</p>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </div>
                                ),
                        )}

                    {/* TODO: 这里显示的逻辑  默认推荐产品 v1.1 已有默认推荐产品 */}
                    {!!isEmpty(searchResultData) && !debouncedValue && (
                        <div className="searchbox-c">
                            <div className="searchbox-c-h">
                                {!!NEW_SEARCH_RESULT_LIST_LOCALES.includes(locale) && (
                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M6 16.6666H4.16699C3.70683 16.6666 3.33313 16.2937 3.33301 15.8336V9.22418C3.33301 8.76394 3.70675 8.39117 4.16699 8.39117H6V16.6666ZM11.5107 2.49469C12.282 2.10921 13.147 2.81522 12.9238 3.64801L11.9482 7.28375C11.8062 7.81304 12.2049 8.33348 12.7529 8.33356H16.6865C17.1389 8.33379 17.5089 8.69472 17.5195 9.14703L17.5234 9.30719C17.545 10.2197 17.3875 11.1279 17.0605 11.98L15.4668 16.1324C15.3431 16.4543 15.0334 16.6666 14.6885 16.6666H7V7.77008L10.3809 3.16266C10.4591 3.05603 10.5614 2.96891 10.6797 2.90973L11.5107 2.49469Z"
                                            fill="url(#paint0_linear_479_12258)"
                                        />
                                        <defs>
                                            <linearGradient
                                                id="paint0_linear_479_12258"
                                                x1="7.99126"
                                                y1="3.63607"
                                                x2="15.7373"
                                                y2="16.0122"
                                                gradientUnits="userSpaceOnUse"
                                            >
                                                <stop stopColor="#F0F0F0" />
                                                <stop offset="1" stopColor="#9A9A9A" />
                                            </linearGradient>
                                        </defs>
                                    </svg>
                                )}

                                <p className="searchbox-content-header-text">
                                    {showType === 'shopifyBundle'
                                        ? i18nText[locale]?.site_nav_search_recommend_bundle || i18nText.en.site_nav_search_recommend_bundle
                                        : i18nText[locale]?.site_nav_search_recommend || i18nText.en.site_nav_search_recommend}
                                </p>
                            </div>
                            {(showType === 'scene' || showType === 'product' || showType === 'shopifyProduct') && (
                                <div className="searchbox-c-list">
                                    {listA?.map((i: any) => {
                                        const currentItem = showType === 'shopifyProduct' ? i?.variants?.[0] : i;
                                        const imagesObj = i?.productImages && JSON.parse(i?.productImages);
                                        const currentImages =
                                            showType === 'shopifyProduct'
                                                ? currentItem?.variantImg || currentItem?.img
                                                : imagesObj?.transparentImages ||
                                                  imagesObj?.images ||
                                                  imagesObj?.navigatorImages ||
                                                  'https://websiteoss.ecoflow.com/upload/image/1755674891865/recommend_file.png';

                                        return (
                                            <EcoLink
                                                className="searchbox-c-item"
                                                key={currentItem?.itemId || currentItem?.productId || currentItem?.variantId}
                                                href={
                                                    currentItem?.url ||
                                                    `https://${locale}.ecoflow.com/products/${currentItem.handle}?variant=${currentItem.variantId}`
                                                }
                                                onClick={() => handleItemClick(currentItem)}
                                            >
                                                <EcoImg pc={currentImages} className="searchbox-c-item-img" />

                                                <div className="searchbox-c-item-info">
                                                    {currentItem?.label && (
                                                        <p className={`searchbox-c-item-tag searchbox-c-item-tag-${i.label}`}>{currentItem?.label || ''}</p>
                                                    )}
                                                    <p className="searchbox-c-item-title">
                                                        {currentItem?.productName ||
                                                            currentItem?.sceneTitle ||
                                                            currentItem?.productTitle ||
                                                            currentItem?.skuTitle}
                                                    </p>
                                                    {currentItem?.price && (
                                                        <div className="searchbox-c-item-price">
                                                            {currentItem?.price && (
                                                                <span className="searchbox-c-item-price1">{FormatMoneyLocal(currentItem?.price, locale)}</span>
                                                            )}
                                                            {currentItem?.compareAtPrice &&
                                                                currentItem?.price &&
                                                                Number(currentItem?.compareAtPrice) > Number(currentItem?.price) && (
                                                                    <span className="searchbox-c-item-price2">
                                                                        {FormatMoneyLocal(currentItem?.compareAtPrice, locale)}
                                                                    </span>
                                                                )}
                                                        </div>
                                                    )}
                                                </div>
                                            </EcoLink>
                                        );
                                    })}
                                    {listA?.length <= 0 && (
                                        <button className="searchbox-c-item-empty">{i18nText[locale]?.search_empty || i18nText.en.search_empty}</button>
                                    )}
                                </div>
                            )}
                            {showType === 'shopifyBundle' && (
                                <div className="searchbox-c-list searchbox-bundles-list">
                                    {/* {searchRes?.items?.map((card: any) => { */}
                                    {listA?.map((card: any) => {
                                        return <EFBundlesCardAI key={card?.itemId} {...card} />;
                                    })}
                                    {listA?.length <= 0 && (
                                        <button className="searchbox-c-item-empty">{i18nText[locale]?.search_empty || i18nText.en.search_empty}</button>
                                    )}
                                </div>
                            )}
                        </div>
                    )}

                    {/* 搜索推荐产品 */}
                    {!isEmpty(searchResultData) && !!NEW_SEARCH_RESULT_LIST_LOCALES.includes(locale) && searchResultData?.products?.content?.length > 0 && (
                        <div className="searchbox-suggested-product-content">
                            <div className="searchbox-c-h">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.5 2L11.7958 8.20423L18 10.5L11.7958 12.7958L9.5 19L7.20423 12.7958L1 10.5L7.20423 8.20423L9.5 2Z"
                                        fill="url(#paint0_linear_548_4080)"
                                    />
                                    <path
                                        d="M15 2L15.8103 4.18973L18 5L15.8103 5.81027L15 8L14.1897 5.81027L12 5L14.1897 4.18973L15 2Z"
                                        fill="url(#paint1_linear_548_4080)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_548_4080"
                                            x1="6.84375"
                                            y1="4.65625"
                                            x2="12.7918"
                                            y2="16.0108"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#F0F0F0" />
                                            <stop offset="1" stopColor="#9A9A9A" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_548_4080"
                                            x1="14.0625"
                                            y1="2.9375"
                                            x2="16.1618"
                                            y2="6.94499"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#F0F0F0" />
                                            <stop offset="1" stopColor="#9A9A9A" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <p className="searchbox-content-header-text">{i18nText[locale]?.suggested_product || i18nText.en.suggested_product}</p>
                            </div>
                            <div className="searchbox-c-list">
                                {searchResultData?.products?.content?.slice(0, 5)?.map((i: any) => {
                                    const currentItem = i?.content;
                                    const imagesObj = currentItem?.images && JSON.parse(currentItem?.images);
                                    const currentImages =
                                        imagesObj?.transparentImages ||
                                        imagesObj?.images ||
                                        imagesObj?.navigatorImages ||
                                        'https://websiteoss.ecoflow.com/upload/image/1755674891865/recommend_file.png';

                                    return (
                                        <EcoLink
                                            className="searchbox-c-item"
                                            key={i?.id}
                                            href={`${websiteUrl}/${locale}/${currentItem.learnLink}`}
                                            onClick={() => handleSuggestedProductItemClick(currentItem)}
                                        >
                                            <EcoImg pc={currentImages} className="searchbox-c-item-img" />

                                            <div className="searchbox-c-item-info">
                                                {currentItem?.label && (
                                                    <p className={`searchbox-c-item-tag searchbox-c-item-tag-${i.label}`}>{currentItem?.label || ''}</p>
                                                )}
                                                <p className="searchbox-c-item-title">{currentItem?.spuName}</p>
                                            </div>
                                        </EcoLink>
                                    );
                                })}
                            </div>
                        </div>
                    )}

                    {/* 搜索文档产品 */}
                    {!isEmpty(searchResultData) && !!NEW_SEARCH_RESULT_LIST_LOCALES.includes(locale) && searchResultData?.supports?.content?.length > 0 && (
                        <div className="searchbox-suggested-doc-content">
                            <div className="searchbox-suggested-doc-header">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path
                                        d="M9.5 2L11.7958 8.20423L18 10.5L11.7958 12.7958L9.5 19L7.20423 12.7958L1 10.5L7.20423 8.20423L9.5 2Z"
                                        fill="url(#paint0_linear_548_4080)"
                                    />
                                    <path
                                        d="M15 2L15.8103 4.18973L18 5L15.8103 5.81027L15 8L14.1897 5.81027L12 5L14.1897 4.18973L15 2Z"
                                        fill="url(#paint1_linear_548_4080)"
                                    />
                                    <defs>
                                        <linearGradient
                                            id="paint0_linear_548_4080"
                                            x1="6.84375"
                                            y1="4.65625"
                                            x2="12.7918"
                                            y2="16.0108"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#F0F0F0" />
                                            <stop offset="1" stopColor="#9A9A9A" />
                                        </linearGradient>
                                        <linearGradient
                                            id="paint1_linear_548_4080"
                                            x1="14.0625"
                                            y1="2.9375"
                                            x2="16.1618"
                                            y2="6.94499"
                                            gradientUnits="userSpaceOnUse"
                                        >
                                            <stop stopColor="#F0F0F0" />
                                            <stop offset="1" stopColor="#9A9A9A" />
                                        </linearGradient>
                                    </defs>
                                </svg>
                                <p className="searchbox-content-header-text">{i18nText[locale]?.suggested_search || i18nText.en.suggested_search}</p>
                            </div>
                            <div className="searchbox-suggested-doc-list">
                                {searchResultData?.supports?.content?.slice(0, 5)?.map((i: any) => {
                                    const currentItem = i?.content;

                                    return (
                                        <p
                                            className="searchbox-suggested-doc-item"
                                            key={currentItem?.Id}
                                            // href={currentItem?.url || `https://www.ecoflow.com${currentItem?.url}`}
                                            onClick={() => handleSuggestedDocItemClick(currentItem)}
                                        >
                                            <p className="searchbox-suggested-doc-item-title" dangerouslySetInnerHTML={{ __html: currentItem?.title }} />
                                        </p>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default DropBoxSearch;
